export const DateMixin = {
    methods: {
        areDaysEqual(day1, day2) {
            if (!day1 || !day2) return;
            return day1.getDate() === day2.getDate() &&
                day1.getMonth() === day2.getMonth() &&
                day1.getFullYear() === day2.getFullYear();
        }
    }
};




// WEBPACK FOOTER //
// ./src/mixins/DateMixin.js